/* eslint-disable */
import React, { Component } from "react";
import { withRouter } from "../../../withRouter";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import cookie from "react-cookies";
import axios from "axios";
import Select from "react-select";
import { apiUrl, adminlimit, clientheaderconfig } from "../../Helpers/Config";
import { GET_LISTDATA } from "../../../actions";
import {
  showStatus,
  encodeValue,
  removeItem,
  showLoader,
  hideLoader,
  showPriceValue
} from "../../Helpers/SettingHelper";
import Header from "../Layout/Header";
import Topmenu from "../Layout/Topmenu";
import Footer from "../Layout/Footer";
import Pagenation from "../Layout/Pagenation";
var module = "products";
var moduleName = "Sell Vouchers";
var qs = require("qs");
class List extends Component {
  constructor(props) {
    super(props);
    var companyID = cookie.load("companyID");
    this.state = {
      companyID: companyID,
      path: this.props?.location?.pathname || '',
      totalRecords: 0,
      totalPage: 0,
      currentPage: 1,
      listdata: [],
      loading: true,
      name: "",
      status: "",
      storeID: "",
      outletList: [],
      listoutlet:[],
      searchKeyWord: "",
      errorMag:false,
      totalSold:0,
      totalSpend:0,
      outstanding:0,
    };
    this.handleChangeText = this.handleChangeText.bind(this);
  }
  componentDidMount() {
    this.loadList(1);
    this.loadOutlet();
  }
  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.listdata !== this.state.listdata) {
      this.setState({
        listoutlet:nextProps.listoutlet,
        listdata: nextProps.listdata,
        loading: false,
        totalRecords: nextProps.totalRecords,
        totalPage: nextProps.totalPages,
        totalSold: nextProps.totalSold,
        totalSpend: nextProps.totalSpend,
        outstanding: nextProps.outstanding,
      });
    }
  }
  loadOutlet() {
    var urlShringTxt =
      apiUrl +
      "outlet/dropdown?company_id=" +
      this.state.companyID;
    axios.get(urlShringTxt, clientheaderconfig).then((res) => {
      if (res.data.status === "ok") {
        this.setState({ outletList: res.data.result });
      }
    }).catch();
  }

  sateValChange = (field, value) => {
    if (field === "page") {
      this.setState(
        {
          loading: true,
          currentPage: value,
        },
        function () {
          this.loadList(value);
        }
      );
    }
  };
  removeItem(deleteID) {
    removeItem(deleteID, module, 'client', this.sateValChange, this.state.currentPage);
  }
  handleChangeText(event) {
    var name = event.target.name;
    var value = event.target.value;
    this.setState({ [name]: value });
  }
  handleSelectChange(name, value) {
    this.setState({ [name]: value }, function () {});
  }

  searchList() {
    this.setState({ loading: true }, function () {
      this.loadList(1);
    });
  }
  loadList(offset) {
    var addParams = "";
    if (this.state.name !== "") {
      addParams += "&name=" + this.state.name;
    }
    if (
      this.state.storeID !== null &&
      Object.keys(this.state.storeID).length > 0
    ) {
      addParams += "&storeID=" + this.state.storeID.value;
    }
    if (
      this.state.status !== null &&
      Object.keys(this.state.status).length > 0
    ) {
      addParams += "&status=" + this.state.status.value;
    }
    addParams += "&producttype=7";
    var params = {
      params:
        "limit=" +
        adminlimit +
        "&offset=" +
        offset +
        addParams,
      url: apiUrl + module,
      authType: "client",
    };
    this.props.getListData(params);
  }
  resetSearch() {
    this.setState(
      {
        loading: true,
        name: "",
        storeID: "",
        status: "",
      },
      function () {
        this.loadList(1);
      }
    );
  }

  getAIData() {
    
    if(this.state.searchKeyWord!=="") {
      this.setState({errorMag:false})
      showLoader('searchAI')
      var postObject = {
        searchKeyWord: this.state.searchKeyWord,
      };
      axios.post(apiUrl + "products/getAIData", postObject, clientheaderconfig).then((res) => {
        hideLoader("searchAI");
        if (res.data.status === "ok") {
          var voucherData = {
            title:res.data.title,
            description:res.data.description
          }
          this.props.navigate("/clientpanel/sell-vouchers/add", {
            state: voucherData,
          });
        }
      });
    }else {
      this.setState({errorMag:true})
    }
  }
  displayOutlet(storedOutletID) {
    if(storedOutletID!=="") {
      var splitstoredOutletID = storedOutletID.split(',');
      var dipslyOutlet = [];
      if(this.state.listoutlet.length>0) {
        this.state.listoutlet.map((item)=> {
          if(splitstoredOutletID.indexOf(item._id) >= 0) {
            dipslyOutlet.push(item.label)
          }
        })
      }
      return dipslyOutlet.join(', ');
    }    
  }

  render() {
    return (
      <div className="layout-wrapper layout-content-navbar">
        <div className="layout-container">
          <Header {...this.props} currentPage={"sell-vouchers"} />
          <div className="layout-page">
            <Topmenu />

            <div className="content-wrapper">
              <div className="container-xxl flex-grow-1 container-p-y">
                <div className="row mb-3">
                  <div className="col-lg-10 col-md-6">
                    <h4 className="fw-bold">{moduleName}</h4>
                  </div>
                  <div className="col-lg-2 col-md-6 text-end">
                    <Link to={this.state.path + "/add"}>
                      <button
                        type="button"
                        className="btn btn-outline-primary waves-effect"
                      >
                        Add New
                      </button>
                    </Link>
                  </div>
                </div>
                <div className="row">
                  <div className="card mb-4">
                    <div className="card-body">
                      <div className="form-floating form-floating-outline" id="searchAI">
                        <input
                          type="text"
                          className={
                            this.state.errorMag === true
                              ? "form-control is-invalid"
                              : "form-control"
                          }
                          value={this.state.searchKeyWord}
                          placeholder="Ask `AI` to create Voucher"
                          aria-describedby="floatingInputHelp"
                          onChange={(event) => {
                            this.setState({
                              searchKeyWord: event.target.value,
                            });
                          }}
                          onKeyPress={(event) => {
                            if (event.key === "Enter") {
                              this.getAIData();
                            }
                          }}
                        />
                        <label htmlFor="floatingInput">
                          Ask `AI` to create Voucher
                        </label>
                        {this.state.errorMag===true &&
                        <span className="error">This field is required.</span>}
                      </div>
                    </div>
                  </div>
                </div>

                <div className="row mb-4 pro-filter-row">
                  <div className="col-md-3 pro-filter-text">
                    <div className="form-floating form-floating-outline mb-4">
                      <input
                        type="text"
                        className="form-control"
                        name="name"
                        onChange={this.handleChangeText}
                        value={this.state.name}
                      />
                      <label htmlFor="name">Product Name</label>
                    </div>
                  </div>

                  <div className="col-md-3 pro-filter-outlet">
                    <div className="form-floating form-floating-outline custm-select-box filter-select mb-4">
                      <Select
                        value={this.state.storeID}
                        onChange={this.handleSelectChange.bind(this, "storeID")}
                        placeholder="Select Outlet"
                        isClearable={true}
                        options={this.state.outletList}
                      />
                      <label className="select-box-label">Outlet</label>
                    </div>
                  </div>
                  <div className="col-md-3 pro-filter-search">
                    <div className="form-floating form-floating-outline custm-select-box filter-select mb-4">
                      <Select
                        value={this.state.status}
                        onChange={this.handleSelectChange.bind(this, "status")}
                        placeholder="Select Status"
                        isClearable={true}
                        options={[
                          { value: "A", label: "Active" },
                          { value: "I", label: "Inactive" },
                        ]}
                      />
                      <label className="select-box-label">Status</label>
                    </div>
                  </div>

                  <div className="col-md-1 mt-2 pro-filter-sbtbtn">
                    <button
                      type="button"
                      className="btn btn-primary me-sm-3 me-1 waves-effect waves-light"
                      onClick={this.searchList.bind(this)}
                    >
                      Search
                    </button>
                  </div>

                  <div className="col-md-1 mt-2 pro-filter-refbtn">
                    <button
                      type="reset"
                      className="btn btn-label-secondary waves-effect"
                      onClick={this.resetSearch.bind(this)}
                    >
                      Reset
                    </button>
                  </div>
                </div>
                <div className="card mb-3">
                  <div className="card-header">
                    <div className="d-flex justify-content-between">
                      <h4 className="mb-2">Sales Overview</h4>
                    </div>
                  </div>
                  <div className="card-body d-flex flex-wrap gap-3">
                    <div className="d-flex gap-3">
                      <div className="avatar">
                        <div className="avatar-initial bg-label-warning rounded">
                          <i className="mdi mdi-currency-usd mdi-24px"></i>
                        </div>
                      </div>
                      <div className="card-info">
                        <h4 className="mb-0">{this.state.totalSold}</h4>
                        <small className="text-muted">Total Sold</small>
                      </div>
                    </div>
                    <div className="d-flex gap-3">
                      <div className="avatar">
                        <div className="avatar-initial bg-label-warning rounded">
                          <i className="mdi mdi-currency-usd mdi-24px"></i>
                        </div>
                      </div>
                      <div className="card-info">
                        <h4 className="mb-0">{this.state.totalSpend}</h4>
                        <small className="text-muted">Total Redeemed</small>
                      </div>
                    </div>
                    <div className="d-flex gap-3">
                      <div className="avatar">
                        <div className="avatar-initial bg-label-warning rounded">
                          <i className="mdi mdi-currency-usd mdi-24px"></i>
                        </div>
                      </div>
                      <div className="card-info">
                        <h4 className="mb-0">{this.state.outstanding}</h4>
                        <small className="text-muted">Outstanding </small>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="card">
                  <div className="p-1 mt-4">
                    <div className={this.state.listdata.length>=3?"table-responsive text-nowrap":''}>
                    <table className="table">
                      <thead>                      
                        <tr>
                        <th>Actions</th>
                        <th>Voucher Name</th>
                        <th>Outlet Name</th>
                        <th>Voucher Type</th>
                        <th>Sorting</th>
                        <th>Price</th>
                        <th>Total Sold Count</th>
                        <th>Total Sold Amount</th>
                        <th>Total Redeemed</th>
                        <th>Balance</th>
                        <th>Status</th>                        
                        </tr>
                      </thead>
                      <tbody>
                        {this.state.loading === true ? (
                          <tr>
                            <td colSpan={7} align="center">
                              <div
                                className="spinner-border spinner-border-lg text-primary"
                                role="status"
                              >
                                <span className="visually-hidden">
                                  Loading...
                                </span>
                              </div>
                            </td>
                          </tr>
                        ) : this.state.listdata.length > 0 ? (
                          this.state.listdata.map((item, index) => {
                            var productTotalBuyAmount = item.productTotalBuyAmount?.$numberDecimal ?? 0;
                            var productTotalBuyCount = item.productTotalBuyCount ?? 0;
                            var productTotalRedeemCount = item.productTotalRedeemCount ?? 0;
                            return (
                              <tr key={index} className={item.productStatus==="I"?'text-danger':''}>
                                <td>
                                  <div className="dropdown">
                                    <button
                                      type="button"
                                      className="btn p-0 dropdown-toggle hide-arrow"
                                      data-bs-toggle="dropdown"
                                    >
                                      <i className="mdi mdi-dots-horizontal"></i>
                                    </button>
                                    <div className="dropdown-menu">
                                      <Link
                                        to={
                                          this.state.path +
                                          "/edit/" +
                                          encodeValue(item._id)
                                        }
                                        className="dropdown-item"
                                      >
                                        <i className="mdi mdi-pencil-outline me-1"></i>
                                        Edit
                                      </Link>
                                      <a
                                        className="dropdown-item"
                                        href={void 0}
                                        onClick={this.removeItem.bind(
                                          this,
                                          encodeValue(item._id)
                                        )}
                                      >
                                        <i className="mdi mdi-trash-can-outline me-1"></i>
                                        Delete
                                      </a>
                                    </div>
                                  </div>
                                </td>
                                <td>
                                  <strong>{item.productName}</strong>
                                </td>
                                <td>{this.displayOutlet(item.productOutletID)}</td>
                                <td>{item.productVoucherType==='C'?'Cash Voucher':'Product Voucher'}</td>
                                <td>{item.productSequence}</td>
                                <td>{showPriceValue(item.productPrice)}</td>
                                <td>{productTotalBuyCount}</td>
                                <td>{showPriceValue(productTotalBuyAmount)}</td>
                                <td>{item.productTotalRedeemCount ?? 0}</td>
                                <td>{parseInt(productTotalBuyCount)- parseInt(productTotalRedeemCount)}</td>
                                <td>{showStatus(item.productStatus)}</td>                                
                              </tr>
                            );
                          })
                        ) : (
                          <tr>
                            <td className="text-center" colSpan={11}>
                              No Vouchers Found
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                    </div>
                  </div>
                  <Pagenation
                    params={{
                      totalRecords: this.state.totalRecords,
                      totalPage: this.state.totalPage,
                      currentPage: this.state.currentPage,
                    }}
                    sateValChange={this.sateValChange}
                  />
                </div>
              </div>

              <Footer />
            </div>
          </div>
        </div>

        <div className="layout-overlay layout-menu-toggle"></div>

        <div className="drag-target"></div>
      </div>
    );
  }
}

const mapStateTopProps = (state) => {
  var listdata = Array();
  let listoutlet = [];
  var totalPages = 0;
  var totalRecords = 0;
  var totalSold = 0;
  var totalSpend = 0;
  var outstanding = 0;
  if (Object.keys(state.listdata).length > 0) {
    if (state.listdata[0].status === "ok") {
      listdata = state.listdata[0].result;
      listoutlet = state.listdata[0].outlet;
      totalPages = state.listdata[0].totalPages;
      totalRecords = state.listdata[0].totalRecords;
      totalSold = state.listdata[0].totalSold;
      totalSpend = state.listdata[0].totalSpend;
      outstanding = state.listdata[0].outstanding;
    }
  }
  return {
    listoutlet:listoutlet,
    listdata: listdata,
    totalPages: totalPages,
    totalRecords: totalRecords,
    totalSold:totalSold,
    totalSpend:totalSpend,
    outstanding:outstanding
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getListData: (datas) => {
      dispatch({ type: GET_LISTDATA, datas });
    },
  };
};

export default withRouter(connect(mapStateTopProps, mapDispatchToProps)(List));
